import React from "react";
import styled from "styled-components";
import Tooltip from "core/Tooltip";
import CC from "core/ReusableIcons/CC";

import { convertPxToRem } from "frontend/components/helpers";

export const TooltipText = styled.p`
    display: block;
    margin-bottom: ${convertPxToRem({ px: 8 })};
`;

export default () => (
    <Tooltip
        title="Creative Commons CC BY-NC-ND 2.0"
        clickToOpen
        message={
            <>
                <TooltipText>Creative Commons CC BY-NC-ND 2.0</TooltipText>
                <TooltipText>
                    You may not crop or edit the photo and you must credit the
                    artist in any use. Otherwise please purchase a royalty-free
                    license.
                </TooltipText>
                <a
                    href="https://thenounproject.com/pricing/#photos"
                    target="_blank"
                >
                    Learn more
                </a>
            </>
        }
    >
        <CC />
    </Tooltip>
);
